import { Button } from "@/components/ui/button";
import { motion } from "framer-motion";
import { ChevronRight } from "lucide-react";
import { C, fadeUp, stagger } from "./data";

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const Footer = ({ navigate }) => (
  <>
    {/* FINAL CTA */}
    <section className="py-24 px-6" style={{ background: C.green }} data-testid="final-cta-section">
      <div className="max-w-3xl mx-auto text-center">
        <motion.div initial="hidden" whileInView="visible" viewport={{ once: true }} variants={stagger}>
          <motion.h2 variants={fadeUp} className="text-4xl md:text-5xl font-bold tracking-tight mb-4" style={{ color: '#FFFFFF' }}>
            Ready to automate governance<span style={{ opacity: 0.6 }}>?</span>
          </motion.h2>
          <motion.p variants={fadeUp} custom={1} className="text-base mb-10 max-w-lg mx-auto" style={{ color: 'rgba(255,255,255,0.8)' }}>
            Book a consultation to see how ZeroZone eliminates compliance overhead and accelerates delivery.
          </motion.p>
          <motion.div variants={fadeUp} custom={2} className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button size="lg" className="font-semibold px-10 py-6 rounded-md text-base" style={{ background: '#FFFFFF', color: C.green }}
              onClick={() => navigate('/wizard')} data-testid="final-cta-btn"
            >
              Start Building <ChevronRight className="w-5 h-5 ml-1" />
            </Button>
            <Button size="lg" variant="outline" className="px-10 py-6 rounded-md text-base" style={{ borderColor: 'rgba(255,255,255,0.4)', color: '#FFFFFF' }}
              onClick={() => navigate('/demo')} data-testid="final-demo-btn"
            >
              See it in action
            </Button>
          </motion.div>
        </motion.div>
      </div>
    </section>

    {/* FOOTER */}
    <footer className="py-12 px-6" style={{ background: C.dark }} data-testid="landing-footer">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-10">
          <div>
            <img src="/zerozone-logo.png" alt="ZeroZone" className="w-28 h-28 object-contain mb-3" />
            <p className="text-xs font-mono leading-relaxed" style={{ color: C.darkText4 }}>
              Audit-Ready Cloud Architecture<span style={{ color: C.green }}>.</span><br />Shipped in Minutes, Not Months<span style={{ color: C.green }}>.</span>
            </p>
          </div>
          <div>
            <h4 className="text-xs font-mono uppercase tracking-wider mb-4" style={{ color: C.darkText4 }}>Product</h4>
            <ul className="space-y-2">
              <li><button onClick={() => navigate('/wizard')} className="text-sm transition-colors" style={{ color: C.darkText4 }} onMouseEnter={e => e.currentTarget.style.color = C.darkText1} onMouseLeave={e => e.currentTarget.style.color = C.darkText4}>Architect My Solution</button></li>
              <li><button onClick={() => navigate('/scan')} className="text-sm transition-colors" style={{ color: C.darkText4 }} onMouseEnter={e => e.currentTarget.style.color = C.darkText1} onMouseLeave={e => e.currentTarget.style.color = C.darkText4}>BYOC Scanner</button></li>
              <li><button onClick={() => navigate('/demo')} className="text-sm font-semibold" style={{ color: C.green }} data-testid="footer-demo-link">Try Demo</button></li>
              <li><a href={`${API_URL}/api/demo/guide`} target="_blank" rel="noopener noreferrer" className="text-sm transition-colors" style={{ color: C.darkText4 }} data-testid="footer-guide-link">Demo Guide</a></li>
            </ul>
          </div>
          <div>
            <h4 className="text-xs font-mono uppercase tracking-wider mb-4" style={{ color: C.darkText4 }}>Compliance</h4>
            <ul className="space-y-2">
              {["SOC 2", "HIPAA", "PCI-DSS", "ISO 27001", "GDPR", "NIST"].map(f => (
                <li key={f}><span className="text-sm" style={{ color: C.darkText4 }}>{f}</span></li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="text-xs font-mono uppercase tracking-wider mb-4" style={{ color: C.darkText4 }}>Company</h4>
            <ul className="space-y-2">
              <li><button onClick={() => navigate('/guide')} className="text-sm transition-colors" style={{ color: C.darkText4 }} onMouseEnter={e => e.currentTarget.style.color = C.darkText1} onMouseLeave={e => e.currentTarget.style.color = C.darkText4}>User Guide</button></li>
              <li><span className="text-sm" style={{ color: C.darkText4 }}>Security</span></li>
              <li><span className="text-sm" style={{ color: C.darkText4 }}>Contact</span></li>
            </ul>
          </div>
        </div>
        <div className="pt-6 flex flex-col md:flex-row items-center justify-between gap-4" style={{ borderTop: `1px solid ${C.darkBorder}` }}>
          <span className="text-xs font-mono" style={{ color: C.darkText4 }}>ZeroZone - Global Resilience Cloud Architect</span>
          <div className="flex items-center gap-4">
            {["SOC 2 TYPE 2", "SECURE DATA"].map(b => (
              <span key={b} className="px-3 py-1 rounded text-[10px] font-mono" style={{ background: 'rgba(0,109,67,0.1)', border: '1px solid rgba(0,109,67,0.2)', color: C.green }}>{b}</span>
            ))}
          </div>
          <span className="text-xs font-mono" style={{ color: C.darkText4 }}>Audit-Ready by Design</span>
        </div>
      </div>
    </footer>
  </>
);
